import type { ContractImportJobDetail } from './types';

import { ENDPOINT } from '~/constants';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodContractImportJobDetailSchema } from './validations';

/**
 * Fetches a single contract import job's details by ID, including the
 * OCR-extracted data, extraction warnings, and available actions. File SAS
 * links are only present on this detail response, never on the list response.
 *
 * @param jobId - The UUID of the import job to fetch.
 * @param options - Additional request options.
 * @returns The import job details.
 * @throws VestigasHTTPError if the API request fails.
 * @see https://app.dev.vestigas.com/redoc#tag/Contract-Import-Jobs/operation/get_import_job_contracts_import_jobs__job_id__get
 */
export const fetchContractImportJob = async (
  jobId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.CONTRACT_IMPORT_JOB.GET(jobId), {
      validate: {
        response: zodContractImportJobDetailSchema,
      },
      ...options,
    })
    .json<ContractImportJobDetail>();
